import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import client from "../../services/client";
import { ENDPOINTS } from "../../config";

export const fetchVendorList = createAsyncThunk(
  "vendor/fetchVendorList",
  async (filters, thunkApi) => {
    try {
      let url = `${ENDPOINTS.getVendor}?page=${filters.pageNo}&size=${filters.pageSize}`;

      // Add keyword if search is not empty
      if (filters?.search?.trim().length > 0) {
        url += `&keyword=${filters.search.trim()}`;
      } 
      // else {
      //   url += `&keyword=`; // Ensure keyword parameter is included even if empty
      // }
      
      // Add status if it's provided
      if (filters.status !== undefined && filters.status !== null) {
        url += `&status=${
          filters.status === "Active" 
            ? true 
            : filters.status === "Inactive" 
            ? false 
            : null
        }`;
      }
      
      console.log(url);
      

      const response = await client.get(url);
      return response;
    } catch (error) {
      return thunkApi.rejectWithValue(error.message);
    }
  }
);

const initialState = {
  vendorList: [],
  totalRows: 0,
  status: "idle", // "idle" | "loading" | "succeeded" | "failed"
  error: null,
};

// Create the slice
const vendorSlice = createSlice({
  name: "vendor",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchVendorList.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchVendorList.fulfilled, (state, action) => {
        state.status = "succeeded";
        const responseVendorList = action.payload?.data?.content.map(
          (listItem) => ({
            ...listItem,
            status: listItem.status ? "Active" : "Inactive",
          })
        );
        state.vendorList = responseVendorList;
        state.totalRows = action.payload?.data?.totalElements || 0;
      })
      .addCase(fetchVendorList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default vendorSlice.reducer;
